import axios from "axios";

const instance = axios.create({
    baseURL: window.prhReactWishlistSidePanel.restBase,
    headers: {
        common: {
            "X-WP-Nonce": window.prhReactWishlistSidePanel.nonce,
        },
    },
});

export default instance;



// WEBPACK FOOTER //
// ./src/wp-axios/axios.js